export default function Tickets() {

    function handleClick(e){
        e.preventDefault();
        // Abrir modal para dar de alta el ticket
    }
    return (
        <>
            <div className="pt-3">
                <h1 className="text-gray-800 fw-bold fs-1">
                    Tickets
                </h1>
                <div className="pt-4">
                    <button onClick={(e) => handleClick(e)}
                       className="btn w-100 text-start custom-list d-flex bg-primary bg-hover-primary-active rounded-1 align-items-center px-5 py-4"
                    >
                        <div className="symbol symbol-50px me-5">
                            <span className="symbol-label bg-white">
                                <i className="ki-outline ki-feather fs-1 text-primary"></i>
                            </span>
                        </div>
                        <div className="d-flex flex-column fw-bold flex-grow-1">
                            <h5 className="custom-list-title fw-semibold text-gray-200 mb-0">
                                Crear Ticket
                            </h5>
                            <span className="text-gray-200 fw-semibold d-none d-sm-none d-md-none d-lg-block" style={{fontSize: '1rem'}}>
                                Reportar una incidencia.
                            </span>
                            <span className="d-sm-block d-md-block d-lg-none">
                                Nuevos servicios.
                            </span>
                        </div>
                    </button>
                </div>
            </div>
            <div className="separator separator-dashed my-8"></div>

        </>
    );
}
